import PropTypes from 'prop-types'
import Spinner from 'react-bootstrap/Spinner'
import { faHourglassEnd } from '@fortawesome/free-solid-svg-icons'
import ReviewModal from '../review/modal'
import Centered from '../review/centered'
import EvidenceBody from './criteria'
import useEvidenceReview from './use-evidence-review'

const EvidenceReviewModal = ({ transaction, analytic, review, onClose, onDecided }) => {
  const { data, isLoading, isError } = useEvidenceReview({
    transactionId: transaction.id,
    analyticId: analytic.id
  })

  const criteria = data?.criteria || []
  const met = criteria.filter((criterion) => criterion.met).length

  const badge = criteria.length === 0
    ? null
    : (
        <div
          style={{
            display: 'flex',
            alignItems: 'baseline',
            gap: 6,
            padding: '8px 14px',
            borderRadius: 'var(--radius-pill)',
            background: 'var(--rust-100)',
            border: '1px solid var(--rust-200)'
          }}
        >
          <span
            style={{
              fontFamily: 'var(--font-mono)',
              fontSize: 'var(--text-xl)',
              fontWeight: 700,
              color: 'var(--rust-700)',
              lineHeight: 1
            }}
          >
            {met}/{criteria.length}
          </span>
          <span
            style={{
              fontSize: 'var(--text-xs)',
              fontWeight: 700,
              color: 'var(--rust-700)',
              textTransform: 'uppercase',
              letterSpacing: '.04em'
            }}
          >
            criteria met
          </span>
        </div>
      )

  const vendorName = data?.subject?.vendor_name || transaction.vendor_name

  return (
    <ReviewModal
      icon={faHourglassEnd}
      title="Dormancy review"
      subtitle={vendorName
        ? `${vendorName} — decide whether this record should stay open for payment.`
        : `Flagged by ${analytic.name}.`}
      badge={badge}
      signals={criteria.filter((criterion) => criterion.met).map((criterion) => criterion.note)}
      analytic={analytic}
      rationale={data?.rationale || analytic.flagged_rationale || analytic.details ||
        'Review the dormancy evidence and decide.'}
      transaction={transaction}
      review={review}
      onClose={onClose}
      onDecided={onDecided}
    >
      {isLoading && (
        <Centered>
          <Spinner animation="border" size="sm" /> <span className="ms-2">Loading the evidence…</span>
        </Centered>
      )}

      {isError && <Centered>Could not load the evidence behind this flag.</Centered>}

      {!isLoading && !isError && !data?.supported && (
        <Centered>
          This finding has no evidence layout yet. {data?.rationale || 'Open the record for the full detail.'}
        </Centered>
      )}

      {!isLoading && !isError && data?.supported && (
        <EvidenceBody window={data.window} criteria={criteria} context={data.context || []} />
      )}
    </ReviewModal>
  )
}

EvidenceReviewModal.propTypes = {
  transaction: PropTypes.object.isRequired,
  analytic: PropTypes.object.isRequired,
  review: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onDecided: PropTypes.func
}

export default EvidenceReviewModal
